import React, { Component } from 'react';
import './CartContainer.scss';
import CartList from '../CartList/index';
import CartTotal from '../CartTotal/index';
import { ProductConsumer } from '../../../../Context';

class CartContainer extends Component {
  render() {
    return (
      <section className='cart'>
        <ProductConsumer>
          {value => {
            const { cart } = value;
            if (!value.displayCart) {
              return (
                <div>
                  <button
                    className='cart__toggle btn'
                    onClick={value.toggleCartOn}
                  >
                    Cart: {cart.length}
                  </button>
                </div>
              );
            } else if (value.displayCart && cart.length > 0) {
              return (
                <div className='cart__container'>
                  <button
                    className='btn cart-btn'
                    onClick={value.toggleCartOff}
                  >
                    Hide
                  </button>
                  <h2>Your Cart</h2>
                  <div className='cart-items'>
                    <CartList value={value} />
                    <CartTotal value={value} />
                  </div>
                  <button
                    className='btn cart-btn buy-btn'
                    disabled={value.corgiInCart ? false : true}
                    onClick={value.checkoutOn}
                  >
                    Buy Now
                  </button>
                </div>
              );
            } else {
              return (
                <div className='cart__container'>
                  <button
                    className='btn cart-btn'
                    onClick={value.toggleCartOff}
                  >
                    Close
                  </button>
                  <p className='cart__empty-text italic'>Your cart is empty</p>
                </div>
              );
            }
          }}
        </ProductConsumer>
      </section>
    );
  }
}

export default CartContainer;
